import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

declare global {
  interface Window {
    __alkaneRecoveryPromise?: Promise<boolean>;
  }
}

async function startApp() {
  if (window.__alkaneRecoveryPromise && (await window.__alkaneRecoveryPromise)) {
    return;
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      () => window.location.reload(),
      { once: true },
    );
  }

  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log(
        "Service Worker registered successfully. App is ready for offline use.",
        registration,
      );
    },
    onUpdate: (registration) => {
      console.log("Service Worker update available.", registration);
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
    },
  });
}

void startApp();
